import req from "../../http";

const viewResume = {
  // 依據 ResumeId 取得 DL & IDL 履歷
  getResume(ResumeId) {
    return req("get", `/ResumeModule/Resume/ViewDetail/${ResumeId}`);
  }
};

export default viewResume;
